export type Tier = 1 | 2 | 3 | 4;

interface Props {
  tier: Tier;
  score?: number;
  resolver?: string;
}

const EXPLAIN: Record<Tier, string> = {
  1: "Direkt erkannt — höchstes Vertrauen",
  2: "Durch zweite Quelle bestätigt",
  3: "Nach mehreren Versuchen entschieden — bitte prüfen",
  4: "System konnte nicht entscheiden — braucht Deine Eingabe",
};

export function TierBadge({ tier, score, resolver }: Props) {
  const pct = score !== undefined ? ` (${Math.round(score * 100)}%)` : "";
  const prefix = resolver ? `${resolver}: ` : "";
  const title = `${prefix}Tier ${tier}${pct}. ${EXPLAIN[tier]}`;
  return (
    <span className={`tier-badge tier-${tier}`} title={title}>
      T{tier}
    </span>
  );
}
